
interface WalkthroughIconProps {
  width?: number;
  height?: number;
}

const WalkthroughIcon = ({ width = 130, height = 130, ...props }: WalkthroughIconProps) => (
    <svg
    width={width}
    height={height}
    viewBox="0 0 130 130"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1293_2539)">
      <path
        d="M113.801 84.1177C102.931 109.525 74.2379 120.438 51.7566 118.577C45.6182 118.069 33.2678 117.047 23.6245 107.927C5.10516 90.4141 7.95729 53.8067 25.6856 32.2543C27.9687 29.4788 43.7715 10.8832 68.3974 11.1321C86.4271 11.3143 99.0819 21.4991 100.621 22.7679C102.565 24.3707 106.852 28.1796 110.716 34.2222C119.795 48.4203 120.593 68.2408 113.801 84.1177Z"
        fill="url(#paint0_linear_1293_2539)"
      />
      <path
        d="M42.1814 59.2984C40.8013 54.3103 41.9487 48.2563 42.2264 42.7733C42.3732 39.8742 42.2607 37.0282 41.4615 34.221C40.6669 31.43 38.9611 28.5128 39.8541 25.5302C41.6535 19.5213 47.8698 21.4127 51.7676 25.3068C56.2906 29.8257 58.3407 37.85 60.5839 43.9493C61.9362 47.6262 63.7554 51.3459 64.6917 55.1458C66.2428 61.4407 65.3298 66.0494 62.6325 69.4112C60.0456 72.6357 55.6525 73.7665 51.8271 72.1992C48.3714 70.7833 44.4078 67.3452 42.1814 59.2984Z"
        fill="#BDD0FB"
      />
      <path
        d="M58.484 81.2524C58.4833 81.2524 58.4826 81.2524 58.4826 81.2524C58.3738 81.2472 58.2904 81.1555 58.2955 81.0475C58.2993 80.9691 58.6529 73.0943 57.4081 62.4288C56.2599 52.5913 53.478 38.3001 46.746 26.082C46.6938 25.9873 46.7283 25.8682 46.823 25.8161C46.9176 25.7639 47.0368 25.7984 47.089 25.893C53.853 38.169 56.646 52.5166 57.798 62.391C59.0458 73.0866 58.6905 80.9875 58.6868 81.0661C58.6816 81.1733 58.5911 81.2564 58.484 81.2524Z"
        fill="url(#paint1_linear_1293_2539)"
      />
      <path
        d="M47.2538 55.2826C46.8068 48.7424 44.2613 42.9913 40.5434 39.0635C37.2199 35.5524 35.3433 30.8963 35.4047 26.0668C35.4112 25.5591 35.3971 25.0449 35.3616 24.5257C34.8241 16.6601 29.5689 10.6131 23.6239 11.0193C17.6788 11.4256 13.2952 18.1313 13.8327 25.9969C13.9426 27.6053 14.2499 29.1373 14.7202 30.5535C16.2209 35.0731 16.0377 40.0058 14.0287 44.3257C12.2332 48.1863 11.3393 52.8107 11.6744 57.714C12.1741 65.027 15.2978 71.3539 19.7501 75.2479C21.4343 76.7208 22.8451 78.4912 23.8892 80.468C25.6242 83.7529 28.6859 85.8499 32.0235 85.6218C35.6242 85.3757 38.5382 82.4927 39.6535 78.5665C40.2845 76.3447 41.345 74.2758 42.7069 72.4083C45.9221 67.9998 47.7057 61.895 47.2538 55.2826Z"
        fill="#91B3FA"
      />
      <path
        d="M26.2772 19.2446C27.4091 24.3899 28.3748 29.5675 29.2863 34.755C29.5148 36.0518 29.7224 37.3521 29.9342 38.6518L30.2515 40.6012L30.5526 42.5534C30.7483 43.8556 30.9619 45.1551 31.1429 46.4596L31.6859 50.3728C32.0146 52.9862 32.3655 55.5967 32.6455 58.2162C32.7874 59.5257 32.9548 60.8321 33.07 62.1445L33.434 66.0792C33.8663 71.3301 34.1667 76.5943 34.2003 81.8634L33.9732 81.8671L33.798 77.9258L33.7563 76.9407L33.6901 75.9566L33.5539 73.9889L33.4214 72.0214C33.3784 71.3655 33.3111 70.7112 33.2571 70.056C33.1405 68.7463 33.0342 67.4359 32.909 66.1271C32.3745 60.8947 31.7705 55.6695 31.0587 50.4574C30.6829 47.8541 30.3295 45.2477 29.9356 42.6468L29.6455 40.6954L29.3391 38.7465C29.1356 37.447 28.9321 36.1475 28.7154 34.8501C28.3043 32.2517 27.8745 29.6559 27.4236 27.0639C26.9863 24.4694 26.5244 21.8785 26.0547 19.2901L26.2772 19.2446Z"
        fill="#BDD0FB"
      />
      <g opacity={0.3}>
        <path
          d="M103.527 29.7807C103.284 29.7708 103.095 29.566 103.105 29.3234C103.125 28.8521 103.124 28.373 103.103 27.8993C103.092 27.6596 103.276 27.4563 103.514 27.4411C103.517 27.4409 103.52 27.4408 103.523 27.4406C103.765 27.4298 103.97 27.6178 103.981 27.8604C104.003 28.359 104.004 28.8634 103.984 29.3596C103.975 29.5864 103.795 29.7661 103.573 29.7802C103.558 29.7812 103.542 29.7815 103.527 29.7807ZM102.842 25.6006C102.757 25.1344 102.651 24.6674 102.527 24.2122C102.463 23.9782 102.601 23.7364 102.835 23.6725C103.071 23.6092 103.311 23.7469 103.375 23.9812C103.506 24.46 103.617 24.9515 103.707 25.442C103.751 25.6809 103.593 25.9099 103.354 25.9537C103.337 25.9568 103.319 25.959 103.302 25.96C103.083 25.974 102.883 25.822 102.842 25.6006ZM101.765 22.0291C101.579 21.5948 101.371 21.1634 101.148 20.7465C101.033 20.5325 101.114 20.266 101.328 20.1514C101.542 20.0372 101.808 20.1175 101.923 20.3315C102.158 20.7705 102.377 21.2249 102.573 21.6822C102.669 21.9053 102.565 22.1638 102.342 22.2597C102.295 22.2801 102.246 22.2914 102.197 22.2945C102.017 22.306 101.84 22.2046 101.765 22.0291ZM99.9161 18.7883C99.637 18.4062 99.3379 18.0318 99.0274 17.6754C98.868 17.4923 98.8871 17.2146 99.0701 17.0551C99.2533 16.8959 99.5308 16.9151 99.6903 17.0978C100.017 17.4732 100.332 17.8674 100.626 18.2694C100.769 18.4654 100.726 18.7405 100.53 18.8837C100.46 18.9349 100.38 18.9624 100.299 18.9675C100.154 18.9767 100.008 18.9141 99.9161 18.7883ZM97.3912 16.0402C97.035 15.7304 96.6605 15.4314 96.2779 15.1518C96.082 15.0084 96.0393 14.7333 96.1826 14.5374C96.3259 14.3413 96.601 14.2987 96.7969 14.4422C97.1993 14.7363 97.5934 15.0509 97.9682 15.3769C98.1514 15.5362 98.1707 15.8139 98.0114 15.9971C97.9311 16.0894 97.8208 16.1401 97.7076 16.1473C97.5961 16.1544 97.4821 16.1193 97.3912 16.0402ZM94.3212 13.9193C93.9047 13.6955 93.4735 13.487 93.0393 13.2993C92.8165 13.203 92.7138 12.9442 92.8102 12.7215C92.9065 12.4986 93.1651 12.396 93.3881 12.4922C93.845 12.6897 94.299 12.9093 94.7373 13.1447C94.9511 13.2597 95.0314 13.5261 94.9165 13.7401C94.8419 13.879 94.7032 13.9614 94.5567 13.9707C94.4776 13.9758 94.3962 13.9596 94.3212 13.9193ZM77.9981 13.7146C77.8838 13.5004 77.9648 13.2341 78.1791 13.1199C78.618 12.8859 79.0731 12.6679 79.5316 12.472C79.755 12.3766 80.0133 12.4804 80.1086 12.7037C80.204 12.9268 80.1003 13.1851 79.877 13.2805C79.4417 13.4664 79.0096 13.6735 78.5929 13.8957C78.5357 13.9262 78.4749 13.9428 78.4142 13.9467C78.2474 13.9572 78.0818 13.8717 77.9981 13.7146ZM90.8595 12.5325C90.404 12.407 89.9374 12.2999 89.4727 12.2141C89.234 12.1698 89.0762 11.9405 89.1203 11.7018C89.1644 11.463 89.3936 11.3065 89.6325 11.3495C90.1218 11.4399 90.6131 11.5527 91.0929 11.6849C91.3269 11.7493 91.4645 11.9913 91.4 12.2254C91.3489 12.4111 91.186 12.536 91.004 12.5476C90.9567 12.5506 90.9079 12.5457 90.8595 12.5325ZM81.523 12.2131C81.4596 11.9789 81.5983 11.7374 81.8327 11.674C82.3127 11.5443 82.8048 11.4335 83.295 11.3446C83.534 11.3002 83.7626 11.46 83.806 11.6988C83.8493 11.9376 83.6907 12.1664 83.4518 12.2098C82.9859 12.2942 82.5183 12.3994 82.0621 12.5229C82.033 12.5307 82.0038 12.5353 81.9748 12.5372C81.7705 12.5502 81.5784 12.4183 81.523 12.2131ZM87.1754 11.9542C86.7035 11.9339 86.2246 11.9336 85.7518 11.9537C85.5091 11.9641 85.3042 11.7758 85.2939 11.5331C85.2838 11.2938 85.467 11.091 85.7051 11.0759C85.7082 11.0757 85.7113 11.0755 85.7144 11.0754C86.2122 11.0542 86.7164 11.0543 87.213 11.0756C87.4557 11.0862 87.6438 11.2912 87.6334 11.5338C87.6237 11.7604 87.444 11.9396 87.2226 11.9536C87.2071 11.9546 87.1913 11.9547 87.1754 11.9542Z"
          fill="#91B3FA"
        />
        <path
          d="M75.8326 15.6396C75.919 15.6341 76.0047 15.6032 76.0777 15.5453C76.2552 15.4042 76.4386 15.2648 76.6228 15.1302C76.8189 14.9871 76.8619 14.7121 76.7188 14.516C76.5757 14.3199 76.3005 14.2766 76.1045 14.4201C75.9107 14.5615 75.7178 14.7083 75.531 14.8566C75.3409 15.0075 75.3091 15.2841 75.46 15.4742C75.5531 15.5914 75.6938 15.6484 75.8326 15.6396Z"
          fill="#91B3FA"
        />
      </g>
      <g opacity={0.3}>
        <path
          d="M69.4236 27.4104C69.6353 27.397 69.812 27.2316 69.8329 27.0136C69.8544 26.788 69.8811 26.5591 69.9122 26.3332C69.9453 26.0927 69.7771 25.8709 69.5366 25.8378C69.2951 25.8046 69.0743 25.9729 69.0412 26.2134C69.0085 26.4512 68.9804 26.6923 68.9576 26.9298C68.9345 27.1715 69.1116 27.3861 69.3533 27.4093C69.3771 27.4116 69.4006 27.4118 69.4236 27.4104Z"
          fill="#91B3FA"
        />
        <path
          d="M86.6684 46.1774C86.4257 46.1809 86.226 45.9869 86.2225 45.744C86.2191 45.5013 86.4128 45.3021 86.6558 45.2982C87.118 45.2916 87.587 45.2651 88.0553 45.2195C88.2957 45.1954 88.5119 45.3729 88.5355 45.6146C88.559 45.8562 88.3822 46.0712 88.1405 46.0947C87.9376 46.1145 87.7352 46.1308 87.5333 46.1436C87.2453 46.1619 86.9543 46.1733 86.6684 46.1774ZM89.9746 45.3751C89.9186 45.1389 90.0648 44.902 90.301 44.8461C90.7545 44.7385 91.2084 44.6108 91.65 44.4661C91.8802 44.3899 92.129 44.5162 92.2047 44.7469C92.2802 44.9775 92.1544 45.2259 91.9238 45.3014C91.4588 45.4538 90.981 45.5884 90.5037 45.7015C90.479 45.7073 90.4542 45.711 90.4297 45.7125C90.2199 45.7259 90.0248 45.5867 89.9746 45.3751ZM84.2764 46.0477C83.791 45.9878 83.3015 45.9064 82.8215 45.8054C82.5839 45.7554 82.4318 45.5223 82.4817 45.2846C82.5317 45.0471 82.7648 44.8953 83.0025 44.945C83.4583 45.041 83.9231 45.1183 84.384 45.1751C84.625 45.2049 84.7963 45.4242 84.7666 45.6653C84.7403 45.8784 84.5654 46.0369 84.3586 46.0501C84.3316 46.0518 84.3042 46.0511 84.2764 46.0477ZM93.5566 44.1987C93.4501 43.9805 93.5406 43.7172 93.7588 43.6108C94.177 43.4067 94.5915 43.1822 94.9907 42.9436C95.1992 42.8189 95.4689 42.887 95.5935 43.0955C95.718 43.3039 95.6501 43.5737 95.4417 43.6982C95.0213 43.9495 94.5848 44.1859 94.1445 44.4009C94.0912 44.4268 94.0354 44.4412 93.9797 44.4447C93.8072 44.4556 93.6371 44.3636 93.5566 44.1987ZM80.5184 45.1529C80.0583 44.9878 79.5989 44.8007 79.1528 44.5967C78.932 44.4958 78.8348 44.2351 78.9356 44.0143C79.0365 43.7933 79.2974 43.6962 79.5182 43.7972C79.942 43.9908 80.3784 44.1686 80.8153 44.3253C81.0438 44.4073 81.1626 44.6591 81.0806 44.8876C81.0195 45.0579 80.8642 45.1672 80.6945 45.178C80.6364 45.1816 80.5766 45.1737 80.5184 45.1529ZM77.0477 43.4555C76.6338 43.1932 76.2262 42.9104 75.8362 42.615C75.6427 42.4683 75.6046 42.1926 75.7512 41.999C75.8981 41.8052 76.1738 41.7673 76.3671 41.9142C76.7377 42.1949 77.125 42.4636 77.5183 42.7129C77.7234 42.8429 77.7842 43.1145 77.6543 43.3196C77.5759 43.4431 77.4461 43.5143 77.3105 43.5229C77.221 43.5287 77.1291 43.5071 77.0477 43.4555ZM74.0292 41.0421C73.6821 40.6957 73.3458 40.3308 73.0296 39.9577C72.8726 39.7724 72.8956 39.4951 73.0808 39.3381C73.2663 39.181 73.5435 39.2041 73.7003 39.3893C74.0008 39.7439 74.3203 40.0905 74.6502 40.4197C74.8221 40.5912 74.8224 40.8696 74.6509 41.0413C74.5721 41.1203 74.4709 41.163 74.3678 41.1696C74.2463 41.1773 74.1222 41.1348 74.0292 41.0421ZM71.6092 38.0277C71.3462 37.6139 71.0979 37.184 70.8712 36.75C70.7588 36.5348 70.8421 36.2692 71.0573 36.1568C71.2722 36.0445 71.538 36.1278 71.6505 36.3429C71.8657 36.755 72.1014 37.1631 72.3513 37.5563C72.4815 37.7612 72.4209 38.0328 72.216 38.1629C72.1513 38.204 72.08 38.2261 72.0085 38.2306C71.8537 38.2405 71.6983 38.1679 71.6092 38.0277ZM69.9097 34.5534C69.7448 34.0929 69.5975 33.6193 69.4718 33.1455C69.4095 32.9108 69.5492 32.67 69.7839 32.6078C70.0178 32.5458 70.2592 32.6851 70.3215 32.9198C70.4409 33.3699 70.5809 33.8197 70.7375 34.2572C70.8193 34.4856 70.7003 34.7373 70.4718 34.8191C70.432 34.8334 70.3915 34.8416 70.3513 34.8442C70.1607 34.8562 69.9773 34.7421 69.9097 34.5534ZM69.0156 30.7946C68.9709 30.437 68.9366 30.0735 68.9139 29.7145C68.9056 29.5844 68.8988 29.4548 68.8935 29.3252C68.8834 29.0827 69.0686 28.8732 69.3144 28.8678C69.5569 28.8576 69.7618 29.0461 69.7719 29.2887C69.7771 29.4118 69.7834 29.5352 69.7913 29.6588C69.813 30.0002 69.8454 30.3455 69.8879 30.6856C69.9181 30.9264 69.7471 31.1461 69.5063 31.1762C69.4972 31.1773 69.4882 31.1782 69.4792 31.1788C69.2491 31.1934 69.0445 31.0265 69.0156 30.7946Z"
          fill="#91B3FA"
        />
        <path
          d="M97.1715 42.4194C97.2587 42.4139 97.345 42.3825 97.4183 42.3238C97.604 42.1749 97.79 42.0192 97.9712 41.8611C98.1542 41.7015 98.1732 41.4238 98.0136 41.2409C97.8539 41.058 97.5764 41.0387 97.3933 41.1985C97.2211 41.3487 97.0444 41.4965 96.8682 41.6379C96.6788 41.7897 96.6484 42.0664 96.8003 42.2558C96.8935 42.3719 97.0335 42.4282 97.1715 42.4194Z"
          fill="#91B3FA"
        />
      </g>
      <path
        d="M98.0017 34.9291C98.0527 34.8577 98.0529 34.762 98.0021 34.6905L96.5539 32.6519C96.9989 31.5722 97.275 30.4138 97.354 29.2146L99.5514 28.0244C99.6285 27.9827 99.6706 27.8966 99.6562 27.8101L99.1655 24.8511C99.1512 24.7646 99.0835 24.6967 98.9971 24.6821L96.5331 24.2649C96.0713 23.1554 95.4361 22.1481 94.6663 21.2699L95.379 18.8729C95.404 18.7889 95.3729 18.6983 95.3016 18.6473L92.8622 16.9019C92.7909 16.8509 92.6951 16.8507 92.6237 16.9015L90.5851 18.3498C89.5054 17.9047 88.347 17.6286 87.1478 17.5496L85.9576 15.3522C85.9159 15.2751 85.8298 15.233 85.7433 15.2474L82.7842 15.7381C82.6977 15.7524 82.6299 15.8201 82.6153 15.9064L82.1981 18.3705C81.0886 18.8323 80.0812 19.4675 79.203 20.2373L76.8061 19.5246C76.7221 19.4996 76.6315 19.5307 76.5805 19.602L74.8351 22.0414C74.7841 22.1126 74.7839 22.2084 74.8346 22.2799L76.2829 24.3185C75.8378 25.3982 75.5618 26.5566 75.4828 27.7558L73.2854 28.946C73.2083 28.9877 73.1662 29.0737 73.1805 29.1602L73.6713 32.1194C73.6856 32.2059 73.7532 32.2737 73.8396 32.2884L76.3036 32.7055C76.7655 33.815 77.4007 34.8224 78.1705 35.7006L77.4578 38.0975C77.4328 38.1815 77.4638 38.2721 77.5352 38.3232L79.9746 40.0686C80.0459 40.1196 80.1417 40.1197 80.2131 40.069L82.2517 38.6207C83.3314 39.0658 84.4898 39.3418 85.6891 39.4208L86.8793 41.6183C86.921 41.6953 87.007 41.7374 87.0935 41.7231L90.0526 41.2323C90.1391 41.218 90.207 41.1504 90.2216 41.0639L90.6387 38.6C91.7483 38.1382 92.7555 37.5029 93.6338 36.7332L96.0307 37.4458C96.1147 37.4708 96.2054 37.4397 96.2564 37.3684L98.0017 34.9291Z"
        fill="#91B3FA"
      />
      <path
        d="M86.1682 31.4898C84.5115 31.352 83.2756 29.8922 83.4133 28.2353C83.4799 27.4327 83.8553 26.7041 84.47 26.1838C85.0845 25.6635 85.865 25.4136 86.6677 25.4805C88.3245 25.6183 89.5603 27.0781 89.4226 28.735C89.2973 30.2423 88.0777 31.4012 86.611 31.4943C86.4656 31.5035 86.3176 31.5022 86.1682 31.4898ZM84.9244 26.7208C84.4531 27.1197 84.1654 27.6783 84.1142 28.2938C84.0087 29.5639 84.9562 30.6834 86.2265 30.789C87.4971 30.895 88.6161 29.947 88.7217 28.6766C88.8273 27.4065 87.8797 26.287 86.6095 26.1814C86.4943 26.1718 86.3799 26.1708 86.2666 26.178C85.7747 26.2093 85.3075 26.3965 84.9244 26.7208Z"
        fill="#BDD0FB"
      />
      <path
        d="M86.8254 35.8442C87.0773 35.8282 87.3299 35.7994 87.5823 35.7576C87.6617 35.7445 87.741 35.73 87.82 35.7143C88.2096 35.6367 88.5923 35.5283 88.9624 35.3907C88.9674 35.3888 88.9724 35.3869 88.9775 35.3851C88.9918 35.3797 89.0061 35.3743 89.0203 35.3687C89.0481 35.3582 89.0758 35.3473 89.1035 35.3365C89.1761 35.3078 89.219 35.236 89.2144 35.162C89.2133 35.144 89.2093 35.1258 89.2023 35.1082C89.1666 35.0179 89.0643 34.974 88.9741 35.0095C88.5094 35.1933 88.0218 35.3282 87.5248 35.4105C85.0562 35.8203 82.6695 34.8899 81.1098 33.1533C80.2421 32.1875 79.6303 30.9722 79.4027 29.5992C79.3627 29.3584 79.3352 29.1174 79.3201 28.8771C79.2176 27.26 79.6706 25.6701 80.6263 24.3347C81.7238 22.8006 83.3532 21.7857 85.214 21.4772C89.0573 20.8402 92.6992 23.4472 93.3362 27.2885C93.3755 27.5254 93.4026 27.7633 93.4176 28.0014C93.4829 29.0329 93.3218 30.0672 92.9421 31.0296C92.9323 31.0545 92.9286 31.0802 92.9303 31.1052C92.9344 31.171 92.9757 31.2319 93.0412 31.2577C93.1317 31.2931 93.2337 31.2492 93.2693 31.1586C93.6679 30.1482 93.8372 29.0622 93.7686 27.9793C93.7529 27.7295 93.7243 27.4797 93.6832 27.2311C93.0144 23.1981 89.1882 20.4616 85.1566 21.1302C83.203 21.4541 81.4926 22.5195 80.3403 24.1301C79.3371 25.532 78.8615 27.2011 78.969 28.8988C78.985 29.151 79.0139 29.404 79.0557 29.6567C79.3798 31.6104 80.4451 33.3208 82.0555 34.4731C83.4578 35.4765 85.1274 35.9519 86.8254 35.8442Z"
        fill="#BDD0FB"
      />
      <g opacity={0.3}>
        <path
          d="M119.278 40.3914C119.395 40.384 119.498 40.3006 119.525 40.1801C119.576 39.9553 119.621 39.7259 119.658 39.4982C119.682 39.3503 119.582 39.2108 119.434 39.1864C119.286 39.1616 119.146 39.2626 119.122 39.4105C119.087 39.6275 119.044 39.8461 118.996 40.0607C118.962 40.2068 119.054 40.3522 119.201 40.3854C119.227 40.3912 119.252 40.393 119.278 40.3914Z"
          fill="#91B3FA"
        />
        <path
          d="M119.521 38.3209C119.371 38.315 119.255 38.189 119.26 38.039C119.275 37.6609 119.27 37.2776 119.246 36.8999C119.241 36.8203 119.235 36.7404 119.228 36.6603C119.216 36.511 119.326 36.3796 119.476 36.367C119.618 36.3606 119.757 36.4653 119.769 36.6148C119.776 36.6986 119.783 36.7821 119.788 36.8655C119.813 37.2613 119.818 37.6633 119.803 38.0599C119.798 38.2002 119.686 38.3117 119.549 38.3204C119.54 38.321 119.531 38.321 119.521 38.3209ZM119.029 35.296C118.935 34.8469 118.812 34.3995 118.664 33.9665C118.616 33.8245 118.691 33.6704 118.833 33.6218C118.974 33.5738 119.129 33.6489 119.178 33.7909C119.333 34.2447 119.462 34.7137 119.56 35.1846C119.591 35.3314 119.497 35.4753 119.35 35.5062C119.337 35.5088 119.324 35.5105 119.311 35.5113C119.179 35.5197 119.057 35.4297 119.029 35.296ZM118.138 32.692C117.937 32.2802 117.708 31.8768 117.457 31.4926C117.375 31.367 117.411 31.1987 117.536 31.1169C117.662 31.0348 117.83 31.0701 117.912 31.1959C118.175 31.5987 118.415 32.0221 118.626 32.4538C118.691 32.5886 118.635 32.7513 118.501 32.817C118.468 32.8328 118.433 32.8417 118.399 32.8439C118.292 32.8506 118.187 32.7938 118.138 32.692ZM116.634 30.3864C116.338 30.0359 116.017 29.7006 115.681 29.3903C115.571 29.2884 115.564 29.1166 115.666 29.0066C115.767 28.8968 115.939 28.8896 116.05 28.9912C116.402 29.3169 116.738 29.6683 117.049 30.0359C117.146 30.1504 117.131 30.3219 117.017 30.4187C116.97 30.4575 116.915 30.4786 116.859 30.4821C116.776 30.4875 116.692 30.4548 116.634 30.3864ZM114.613 28.5179C114.241 28.2501 113.848 28.0029 113.447 27.7829C113.315 27.711 113.267 27.5459 113.339 27.4143C113.411 27.2828 113.576 27.2343 113.708 27.3067C114.129 27.5372 114.54 27.7964 114.93 28.0769C115.052 28.1645 115.08 28.3342 114.992 28.4558C114.943 28.5246 114.867 28.5634 114.789 28.5684C114.728 28.5722 114.666 28.5559 114.613 28.5179ZM112.2 27.1965C111.774 27.0275 111.334 26.8835 110.891 26.7687C110.746 26.7311 110.658 26.5828 110.696 26.4378C110.734 26.2927 110.881 26.2057 111.027 26.243C111.491 26.3633 111.954 26.5144 112.4 26.6917C112.54 26.7472 112.608 26.9049 112.552 27.0442C112.512 27.145 112.419 27.2086 112.317 27.215C112.278 27.2176 112.238 27.2119 112.2 27.1965ZM109.538 26.5057C109.085 26.4465 108.622 26.415 108.163 26.4123C108.013 26.4112 107.892 26.289 107.893 26.1391C107.894 25.9892 108.016 25.8706 108.166 25.869C108.648 25.8722 109.133 25.9052 109.608 25.9672C109.757 25.9867 109.862 26.123 109.842 26.2717C109.825 26.4025 109.717 26.4993 109.59 26.5074C109.573 26.5085 109.556 26.508 109.538 26.5057ZM105.101 26.5334C105.065 26.3877 105.154 26.2409 105.3 26.2053C105.703 26.1069 106.119 26.029 106.534 25.9737C106.597 25.9649 106.66 25.9572 106.723 25.9498C106.871 25.9282 107.007 26.0391 107.024 26.1884C107.041 26.3374 106.934 26.472 106.786 26.4894C106.726 26.4961 106.667 26.5035 106.607 26.5119C106.21 26.5647 105.813 26.639 105.429 26.7328C105.413 26.7367 105.397 26.7391 105.381 26.74C105.252 26.7483 105.132 26.6632 105.101 26.5334Z"
          fill="#91B3FA"
        />
      </g>
      <g opacity={0.3}>
        <path
          d="M108.664 49.31C108.191 49.3339 107.713 49.3289 107.243 49.2958C107.093 49.2851 106.98 49.1554 106.991 49.0057C107.001 48.856 107.132 48.7448 107.281 48.754C107.73 48.7858 108.186 48.7904 108.637 48.7676C108.786 48.7599 108.914 48.8754 108.921 49.025C108.929 49.1736 108.815 49.3004 108.668 49.3098C108.668 49.3098 108.665 49.3099 108.664 49.31ZM109.764 48.9315C109.738 48.7838 109.837 48.6433 109.985 48.618C110.43 48.5414 110.874 48.4372 111.306 48.308C111.449 48.2658 111.601 48.3467 111.644 48.4906C111.687 48.6343 111.605 48.7853 111.462 48.8284C111.009 48.9637 110.543 49.073 110.077 49.153C110.068 49.1547 110.058 49.1558 110.048 49.1564C109.912 49.1652 109.788 49.0697 109.764 48.9315ZM105.833 49.1087C105.368 49.0176 104.905 48.8974 104.456 48.7513C104.314 48.7048 104.236 48.5515 104.282 48.409C104.329 48.2663 104.481 48.1889 104.625 48.2348C105.052 48.3742 105.494 48.4889 105.937 48.576C106.084 48.605 106.18 48.7476 106.151 48.8945C106.127 49.0183 106.022 49.1057 105.902 49.1133C105.879 49.1148 105.856 49.1134 105.833 49.1087ZM112.439 48.1984C112.379 48.0611 112.442 47.9009 112.579 47.8407C112.992 47.6596 113.398 47.4513 113.786 47.2213C113.915 47.1451 114.081 47.1877 114.158 47.3162C114.234 47.4452 114.192 47.6118 114.063 47.6883C113.656 47.9296 113.23 48.1482 112.797 48.338C112.767 48.3511 112.736 48.3583 112.705 48.3603C112.595 48.3673 112.486 48.3056 112.439 48.1984ZM103.135 48.2294C102.707 48.0297 102.286 47.8016 101.885 47.5515C101.758 47.4722 101.719 47.3046 101.799 47.1774C101.878 47.0501 102.045 47.0111 102.173 47.0907C102.555 47.3294 102.956 47.5468 103.364 47.7372C103.5 47.8005 103.559 47.9621 103.496 48.0981C103.452 48.1912 103.362 48.2482 103.267 48.2543C103.223 48.257 103.177 48.2493 103.135 48.2294ZM100.726 46.7285C100.358 46.4314 100.004 46.1093 99.6749 45.7713C99.5704 45.6639 99.5726 45.4921 99.6801 45.3875C99.7873 45.283 99.9593 45.285 100.064 45.3926C100.378 45.7149 100.715 46.0221 101.067 46.3056C101.184 46.3997 101.202 46.5707 101.108 46.6875C101.058 46.7491 100.987 46.7834 100.914 46.788C100.848 46.7922 100.781 46.7727 100.726 46.7285ZM98.7464 44.6938C98.4595 44.317 98.1933 43.9192 97.9551 43.5118C97.8794 43.3822 97.9231 43.216 98.0525 43.1403C98.1819 43.0646 98.3482 43.1086 98.4239 43.2376C98.6509 43.6262 98.9048 44.0055 99.1785 44.3646C99.2693 44.4839 99.2463 44.6544 99.1269 44.7451C99.0827 44.779 99.0315 44.7969 98.9799 44.8001C98.8924 44.8057 98.8037 44.7689 98.7464 44.6938Z"
          fill="#91B3FA"
        />
        <path
          d="M115.101 46.938C115.153 46.9347 115.205 46.9163 115.25 46.8818C115.434 46.7397 115.614 46.5914 115.786 46.4413C115.899 46.3427 115.911 46.1711 115.812 46.0581C115.714 45.9456 115.542 45.9336 115.429 46.032C115.265 46.1752 115.093 46.3166 114.917 46.4523C114.799 46.5441 114.777 46.7147 114.869 46.8332C114.926 46.9072 115.014 46.9435 115.101 46.938Z"
          fill="#91B3FA"
        />
      </g>
      <path
        d="M115.822 41.8195C115.856 41.7718 115.856 41.7077 115.822 41.6599L114.853 40.2957C115.151 39.5733 115.336 38.7981 115.389 37.9957L116.859 37.1992C116.911 37.1713 116.939 37.1137 116.929 37.0558L116.601 35.0757C116.591 35.0179 116.546 34.9724 116.488 34.9626L114.839 34.6835C114.53 33.9411 114.105 33.267 113.59 32.6793L114.067 31.0754C114.084 31.0192 114.063 30.9586 114.015 30.9244L112.383 29.7565C112.335 29.7224 112.271 29.7222 112.223 29.7562L110.859 30.7253C110.137 30.4275 109.361 30.2428 108.559 30.1899L107.763 28.7195C107.735 28.6679 107.677 28.6398 107.619 28.6494L105.639 28.9777C105.581 28.9873 105.536 29.0326 105.526 29.0904L105.247 30.7392C104.504 31.0482 103.83 31.4733 103.243 31.9884L101.639 31.5115C101.583 31.4948 101.522 31.5155 101.488 31.5632L100.32 33.1956C100.286 33.2433 100.286 33.3074 100.32 33.3552L101.289 34.7194C100.991 35.4418 100.806 36.217 100.753 37.0195L99.283 37.8159C99.2314 37.8438 99.2032 37.9014 99.2128 37.9593L99.5412 39.9394C99.5508 39.9972 99.596 40.0426 99.6538 40.0524L101.303 40.3316C101.612 41.074 102.037 41.7481 102.552 42.3357L102.075 43.9396C102.058 43.9959 102.079 44.0565 102.127 44.0906L103.759 45.2586C103.807 45.2927 103.871 45.2928 103.919 45.2589L105.283 44.2897C106.005 44.5876 106.78 44.7723 107.583 44.8251L108.379 46.2956C108.407 46.3472 108.465 46.3753 108.523 46.3657L110.503 46.0373C110.561 46.0277 110.606 45.9825 110.616 45.9247L110.895 44.2759C111.637 43.9669 112.311 43.5417 112.899 43.0267L114.503 43.5036C114.559 43.5203 114.62 43.4995 114.654 43.4518L115.822 41.8195Z"
        fill="#91B3FA"
      />
      <path
        d="M107.9 39.5542C107.353 39.509 106.857 39.2533 106.502 38.8345C106.148 38.4159 105.978 37.8842 106.023 37.3375C106.117 36.209 107.11 35.3688 108.24 35.4608C109.369 35.5549 110.211 36.5494 110.117 37.6776C110.071 38.2243 109.816 38.7206 109.397 39.0751C109.057 39.3631 108.642 39.5295 108.204 39.5572C108.104 39.5635 108.002 39.5626 107.9 39.5542ZM106.564 37.3823C106.531 37.7845 106.656 38.1756 106.917 38.4837C107.178 38.7916 107.543 38.9796 107.945 39.0131C108.347 39.046 108.738 38.9213 109.046 38.6605C109.354 38.4 109.542 38.0347 109.576 37.6327C109.645 36.8026 109.025 36.0711 108.195 36.0019C108.12 35.9958 108.046 35.9951 107.973 35.9997C107.238 36.0464 106.627 36.6272 106.564 37.3823Z"
        fill="#BDD0FB"
      />
      <path
        d="M108.358 42.5848C108.529 42.5739 108.702 42.5542 108.875 42.5256C109.218 42.4688 109.556 42.3769 109.88 42.2522C109.895 42.2465 109.909 42.2408 109.924 42.2351C110.036 42.1907 110.102 42.08 110.095 41.9657C110.093 41.9379 110.087 41.9098 110.076 41.8827C110.021 41.7432 109.863 41.6756 109.724 41.7302C109.423 41.8495 109.107 41.9368 108.786 41.9898H108.786C108.768 41.9928 108.75 41.9955 108.733 41.9982C107.972 42.1169 107.21 42.0414 106.504 41.7887C106.12 41.6515 105.753 41.4618 105.411 41.2218C105.408 41.2198 105.406 41.2179 105.403 41.2159C105.394 41.2098 105.386 41.204 105.378 41.1979C104.385 40.4872 103.728 39.4325 103.528 38.2278C103.502 38.0719 103.484 37.916 103.474 37.7604C103.408 36.7136 103.701 35.6843 104.32 34.8196C105.03 33.8265 106.085 33.1697 107.29 32.97C108.494 32.7709 109.705 33.0516 110.698 33.762C111.691 34.4726 112.348 35.5274 112.548 36.732C112.573 36.8853 112.591 37.0394 112.601 37.1934C112.643 37.8613 112.539 38.5308 112.293 39.1537C112.278 39.1921 112.272 39.2318 112.274 39.2705C112.281 39.3721 112.345 39.4661 112.446 39.5059C112.585 39.5605 112.743 39.4926 112.798 39.3528C113.073 38.6557 113.19 37.9065 113.143 37.1595C113.132 36.987 113.112 36.8147 113.084 36.6433C112.86 35.2954 112.125 34.1153 111.014 33.3203C109.903 32.5255 108.549 32.2097 107.201 32.4342C105.853 32.6576 104.673 33.3925 103.878 34.5038C103.186 35.471 102.858 36.6226 102.932 37.7938C102.943 37.9676 102.963 38.1423 102.992 38.3165C103.425 40.926 105.773 42.7488 108.358 42.5848Z"
        fill="#BDD0FB"
      />
      <path
        d="M16.6905 99.762C16.6905 100.721 17.4762 101.506 18.4366 101.506H112.858C113.818 101.506 114.604 100.721 114.604 99.762L115.389 45.5008C115.389 44.5414 114.259 42.6684 112.187 42.8091L19.9088 40.4214C18.7038 40.3903 17.5388 40.854 16.6855 41.7045C15.8322 42.555 15.3653 43.7179 15.3938 44.9217L16.6905 99.762Z"
        fill="url(#paint2_linear_1293_2539)"
      />
      <path
        d="M18.4139 98.0885C18.4139 98.997 19.1573 99.7404 20.0658 99.7404H110.58C111.489 99.7404 112.232 98.997 112.232 98.0885L112.973 48.8297C112.886 45.8654 110.287 44.8 108.712 44.8629L20.2713 42.4902C19.4247 42.4675 18.6063 42.7936 18.0067 43.3917C17.4071 43.9897 17.0774 44.8082 17.0986 45.6548L18.4139 98.0885Z"
        fill="#7D97F4"
      />
      <path
        d="M20.9254 96.1629C20.9254 96.9846 21.6163 97.657 22.4607 97.657H106.583C107.427 97.657 108.118 96.9846 108.118 96.1629L108.807 51.6096C108.726 48.9285 106.31 47.9649 104.846 48.0218L22.6516 45.8757C21.8649 45.8552 21.1042 46.1502 20.547 46.6911C19.9898 47.232 19.6833 47.9722 19.703 48.7379L20.9254 96.1629Z"
        fill="#91B3FA"
      />
      <path
        d="M111.254 67.9178C111.253 67.9178 111.252 67.9178 111.251 67.9178C111.117 67.9163 111.01 67.8314 111.012 67.7281L111.071 64.6456C111.073 64.5434 111.181 64.4615 111.313 64.4615C111.314 64.4615 111.315 64.4615 111.316 64.4615C111.45 64.4631 111.557 64.5479 111.555 64.6512L111.496 67.7337C111.494 67.8359 111.386 67.9178 111.254 67.9178Z"
        fill="url(#paint3_linear_1293_2539)"
      />
      <path
        d="M111.398 60.3639C111.397 60.3639 111.396 60.3639 111.394 60.3639C111.261 60.3624 111.154 60.2774 111.156 60.1743L111.38 48.3681C111.376 47.6668 111.1 47.1069 110.56 46.7077C109.553 45.9626 107.952 46.0006 107.885 46.0031L79.6174 45.4181C79.4838 45.4155 79.3783 45.3295 79.3819 45.2264C79.3855 45.1233 79.4881 45.0355 79.6305 45.0448L107.881 45.6298C108.057 45.6218 109.761 45.599 110.895 46.4379C111.534 46.9098 111.86 47.56 111.865 48.37L111.64 60.1799C111.638 60.2821 111.53 60.3639 111.398 60.3639Z"
        fill="url(#paint4_linear_1293_2539)"
      />
      <path
        d="M13.0661 105.437H117.373C117.493 105.437 117.592 105.339 117.592 105.218V101.462C117.592 101.342 117.493 101.243 117.373 101.243H13.0661C12.9457 101.243 12.8472 101.342 12.8472 101.462V105.218C12.8472 105.339 12.9457 105.437 13.0661 105.437Z"
        fill="url(#paint5_linear_1293_2539)"
      />
      <path
        d="M75.17 82.1295C74.0251 85.9005 70.5169 88.6522 66.3775 88.6522C61.3133 88.6522 57.1925 84.5315 57.1925 79.466C57.1925 76.6797 58.4402 74.1789 60.4059 72.4921L60.0175 68.6837C56.3318 70.8655 53.8564 74.8822 53.8564 79.466C53.8564 86.3703 59.4731 91.9883 66.3775 91.9883C70.7478 91.9883 74.6029 89.7371 76.8434 86.3329L75.17 82.1295Z"
        fill="white"
      />
      <path
        d="M80.8783 88.2143C80.6711 88.2143 80.4638 88.1758 80.267 88.0983C79.8387 87.9296 79.4991 87.5188 79.3286 87.0911L75.0766 76.3415H64.3313C63.4755 76.3415 62.7585 75.7661 62.6718 74.9148L61.1855 60.3612C61.0921 59.4446 61.7594 58.6441 62.6759 58.5507C63.5916 58.4568 64.411 59.1694 64.5044 60.0858L65.838 73.2214H76.2078C76.8907 73.2214 77.5048 73.6021 77.7575 74.2366L81.7711 84.2974L84.9697 82.7772C85.8029 82.3832 86.797 82.7355 87.1904 83.5683C87.584 84.4011 87.2278 85.3932 86.3948 85.7868L81.5909 88.0555C81.3659 88.1619 81.1223 88.2143 80.8783 88.2143Z"
        fill="white"
      />
      <path
        d="M73.539 70.1011H63.6641C62.7429 70.1011 61.9961 69.3756 61.9961 68.4544C61.9961 67.5332 62.7429 66.8076 63.6641 66.8076H73.539C74.4602 66.8076 75.207 67.5332 75.207 68.4544C75.207 69.3756 74.4602 70.1011 73.539 70.1011Z"
        fill="white"
      />
      <path
        d="M63.9755 61.8518C65.9654 61.8518 67.5785 60.2387 67.5785 58.2488C67.5785 56.259 65.9654 54.6458 63.9755 54.6458C61.9857 54.6458 60.3726 56.259 60.3726 58.2488C60.3726 60.2387 61.9857 61.8518 63.9755 61.8518Z"
        fill="white"
      />
      <path
        d="M22.5629 70.9033C22.3965 77.4152 21.8568 99.8774 22.1144 107.837C22.1417 108.681 22.8385 109.357 23.7077 109.385C28.0066 109.522 40.3733 109.867 47.4048 109.581C48.8693 109.522 50.034 108.371 50.0644 106.949C50.2105 100.114 50.5329 80.8891 49.7666 72.0823C49.6748 71.0271 48.8211 70.1869 47.7351 70.0814C43.0534 69.6271 30.6189 68.5164 24.5441 68.8988C23.4486 68.9679 22.5901 69.8385 22.5629 70.9033Z"
        fill="url(#paint6_linear_1293_2539)"
      />
      <path
        d="M24.3098 72.9268C24.0749 78.26 23.3343 96.0024 23.5694 102.563C23.6038 103.522 24.3828 104.298 25.3702 104.354C29.4353 104.584 39.862 105.093 45.8245 104.63C46.8982 104.547 47.7407 103.704 47.7986 102.661C48.1008 97.2198 48.9684 80.6991 48.7431 74.2118C48.7071 73.1769 47.8808 72.3318 46.8178 72.2392C42.42 71.8561 31.1249 70.9446 26.0581 71.2128C25.1069 71.2631 24.3504 72.0035 24.3098 72.9268Z"
        fill="#7D97F4"
      />
      <path
        d="M24.8673 73.8475C24.6454 78.876 23.9453 95.6048 24.1675 101.791C24.2 102.695 24.9364 103.426 25.8697 103.479C29.7124 103.696 39.5686 104.176 45.2049 103.74C46.2198 103.661 47.0162 102.867 47.071 101.883C47.3566 96.7526 48.1767 81.1758 47.9637 75.0592C47.9297 74.0834 47.1486 73.2865 46.1438 73.1992C41.9866 72.838 31.3095 71.9786 26.52 72.2315C25.6209 72.2789 24.9057 72.9769 24.8673 73.8475Z"
        fill="#91B3FA"
      />
      <path
        opacity={0.5}
        d="M33.187 70.0368C33.187 70.2366 33.3475 70.4014 33.5532 70.4118C34.5686 70.4634 37.4289 70.6094 38.7071 70.6813C38.9592 70.6955 39.157 70.4757 39.1092 70.2352L39.1011 70.1941C39.0684 70.03 38.9281 69.9065 38.7566 69.8913C37.8925 69.8144 35.2852 69.6015 33.5577 69.6613C33.3502 69.6685 33.187 69.8353 33.187 70.0368Z"
        fill="white"
      />
      <path
        d="M41.5456 80.8323L40.9079 80.3089C40.7506 80.1797 40.5086 80.196 40.3674 80.3456L30.2129 91.0981C30.0664 91.2532 30.0791 91.4842 30.2414 91.6139L30.8991 92.1393C31.0611 92.2687 31.3108 92.2477 31.4567 92.0925L41.5752 81.3367C41.7159 81.1871 41.7027 80.9613 41.5456 80.8323Z"
        fill="white"
      />
      <path
        d="M36.9145 82.4572V82.8505L31.237 88.9108H30.3468C29.9941 88.9108 29.708 88.7531 29.708 88.4004V84.0453C29.708 83.6927 29.994 83.391 30.3468 83.391H32.9279V83.4202C34.0012 82.9072 35.0306 82.3955 36.0763 81.8826C36.2736 81.7864 36.4887 81.7987 36.6748 81.9146C36.8622 82.0317 36.9145 82.2365 36.9145 82.4572Z"
        fill="white"
      />
      <path
        d="M34.5649 89.832L36.9154 87.2969V89.9886C36.9154 90.2093 36.8448 90.414 36.6574 90.5311C36.4712 90.647 36.2443 90.6594 36.047 90.562C35.5501 90.319 35.0606 90.0749 34.5649 89.832Z"
        fill="white"
      />
      <path
        d="M41.4257 86.3647C41.4257 87.8221 40.8918 89.155 40.0101 90.1797C39.8289 90.3893 39.5083 90.4053 39.3122 90.208L39.2925 90.1895C39.1186 90.0144 39.1051 89.7346 39.2666 89.5471C40.0039 88.6939 40.4503 87.5816 40.4503 86.3646C40.4503 85.5743 40.2616 84.8282 39.9263 84.1686L40.6304 83.4201C41.1359 84.2858 41.4257 85.292 41.4257 86.3647Z"
        fill="white"
      />
      <path
        d="M39.8012 86.3646C39.8012 87.372 39.4486 88.2956 38.8603 89.0219C38.6841 89.2388 38.3573 89.2524 38.1588 89.0551L38.1563 89.0514C37.9824 88.8788 37.9738 88.6038 38.1267 88.4127C38.578 87.8528 38.8492 87.1402 38.8492 86.3646C38.8492 86.0477 38.8036 85.742 38.7185 85.4522L39.4485 84.6766C39.6754 85.1933 39.8012 85.7641 39.8012 86.3646Z"
        fill="white"
      />
      <path
        d="M43.0129 89.3231C42.9176 93.6849 42.6085 108.73 42.756 114.062C42.7717 114.627 43.1707 115.08 43.6684 115.099C46.1302 115.19 53.212 115.422 57.2387 115.23C58.0773 115.19 58.7443 114.419 58.7617 113.467C58.8454 108.889 59.03 96.0117 58.5912 90.1128C58.5386 89.406 58.0498 88.8432 57.4278 88.7726C54.7469 88.4682 47.6262 87.7243 44.1474 87.9805C43.52 88.0267 43.0284 88.6098 43.0129 89.3231Z"
        fill="url(#paint7_linear_1293_2539)"
      />
      <path
        d="M44.0135 90.6784C43.879 94.2506 43.4549 106.135 43.5895 110.529C43.6092 111.172 44.0553 111.691 44.6207 111.729C46.9486 111.883 52.9195 112.224 56.334 111.914C56.9488 111.858 57.4313 111.294 57.4645 110.595C57.6375 106.95 58.1343 95.8844 58.0053 91.5391C57.9847 90.8459 57.5116 90.2798 56.9028 90.2178C54.3844 89.9612 47.9162 89.3507 45.0147 89.5303C44.47 89.564 44.0368 90.0599 44.0135 90.6784Z"
        fill="#7D97F4"
      />
      <path
        d="M44.5024 91.4413C44.3776 94.7551 43.9843 105.779 44.1091 109.855C44.1274 110.451 44.5412 110.933 45.0657 110.968C47.2251 111.111 52.7638 111.428 55.9311 111.14C56.5015 111.088 56.949 110.564 56.9798 109.916C57.1403 106.535 57.6012 96.2706 57.4815 92.2398C57.4624 91.5968 57.0235 91.0716 56.4588 91.0141C54.1226 90.7761 48.1226 90.2098 45.4311 90.3764C44.9258 90.4077 44.524 90.8677 44.5024 91.4413Z"
        fill="#91B3FA"
      />
      <path
        opacity={0.5}
        d="M49.0967 88.7426C49.0967 88.8764 49.1886 88.9868 49.3064 88.9938C49.8878 89.0283 51.5258 89.1261 52.2578 89.1743C52.4022 89.1838 52.5154 89.0366 52.4881 88.8755L52.4834 88.848C52.4647 88.7381 52.3844 88.6554 52.2861 88.6451C51.7913 88.5937 50.2982 88.451 49.309 88.4911C49.1901 88.4959 49.0967 88.6077 49.0967 88.7426Z"
        fill="white"
      />
      <path
        d="M53.8089 99.0327L52.8081 100.172C52.8622 100.338 52.8942 100.512 52.9003 100.693C52.9366 101.757 52.083 102.645 50.9891 102.679C50.8645 102.683 50.7431 102.675 50.6248 102.658L50.1997 103.141C50.4638 103.169 50.7325 103.178 51.0058 103.169C52.9983 103.107 54.7011 102.093 55.6326 100.621C55.162 99.9725 54.5384 99.4285 53.8089 99.0327ZM50.8571 98.8096C50.9548 98.8072 51.0511 98.8125 51.1459 98.824L51.5659 98.3474C51.3279 98.3243 51.086 98.3144 50.8403 98.3193C48.8307 98.361 47.0836 99.3729 46.1157 100.87C46.5931 101.515 47.2202 102.056 47.9478 102.45L49.0021 101.254C48.9599 101.108 48.9348 100.955 48.9293 100.796C48.8927 99.7233 49.7576 98.8341 50.8571 98.8096Z"
        fill="white"
      />
      <path
        d="M54.7104 96.8301L54.2507 96.4783C54.1373 96.3914 53.968 96.4087 53.8725 96.5169L47.0087 104.3C46.9096 104.413 46.924 104.574 47.0409 104.661L47.5147 105.014C47.6314 105.101 47.806 105.08 47.9047 104.968L54.7432 97.1831C54.8383 97.0748 54.8237 96.9168 54.7104 96.8301Z"
        fill="white"
      />
      <path
        d="M96.0458 82.7851C96.5306 83.4743 97.0687 84.1311 97.6214 84.767C98.141 85.3649 98.6849 85.9431 99.2622 86.4868C99.6222 86.8257 99.9109 87.2651 100.348 87.5176C100.671 87.7041 100.691 87.6492 100.903 87.4136C101.245 87.0341 101.635 86.8218 102.023 87.1667C102.326 87.4361 102.729 87.6841 102.907 88.0604C103.097 88.4629 102.836 90.7343 102.158 90.5732C102.155 90.5726 99.1108 89.8481 95.8589 83.4768L96.0458 82.7851Z"
        fill="url(#paint8_linear_1293_2539)"
      />
      <path
        d="M96.6886 84.2831C96.6792 84.3835 97.0553 84.4529 97.1749 84.0249C97.1421 83.839 97.0836 83.0251 96.9401 82.8987C96.1757 82.2253 94.8127 81.4677 94.8127 81.4677C94.6602 81.6988 94.8602 81.851 94.8602 81.851L95.5406 82.3069C95.4696 82.5403 95.366 82.7467 95.3543 83.0132C95.3454 83.215 95.4205 83.4126 95.5554 83.5656C95.6908 83.7192 95.8731 83.9176 96.0374 84.0682C96.3484 84.3532 96.6886 84.2831 96.6886 84.2831Z"
        fill="url(#paint9_linear_1293_2539)"
      />
      <path
        d="M96.7148 83.3362L96.4637 82.9458L95.8648 82.6279C95.7714 82.7036 95.7319 82.8043 95.8843 82.9624C96.0366 83.1205 96.3712 83.93 96.3712 83.93L96.7148 83.3362Z"
        fill="url(#paint10_linear_1293_2539)"
      />
      <path
        d="M103.824 94.1381C103.1 95.6493 107.888 96.6381 112.106 97.3128L112.184 87.1751C112.184 87.1751 112.829 82.8754 109.884 82.3983C108.15 81.9588 108.15 81.9629 108.15 81.9629C108.15 81.9629 105.931 81.6413 104.075 82.4044C102.22 83.1677 100.843 87.3082 100.843 87.3082L102.881 89.6605C102.918 89.7025 102.987 89.6873 103.002 89.6339L103.697 87.4762L103.824 94.1381Z"
        fill="url(#paint11_linear_1293_2539)"
      />
      <path
        d="M107.867 86.7413C107.888 86.7031 107.899 86.6573 107.91 86.6163C107.962 86.4283 108.051 86.239 108.118 86.0537C108.151 85.9636 108.184 85.8735 108.216 85.7833C108.241 85.7159 108.305 85.6097 108.305 85.5387C108.544 84.8826 108.783 84.2265 109.022 83.5704C109.029 83.5496 109.019 83.5266 108.998 83.5191C108.977 83.5116 108.954 83.5223 108.946 83.5431C108.855 83.7925 108.764 84.0422 108.673 84.2917C108.503 84.761 108.332 85.2302 108.161 85.6995C108.087 85.9027 108.013 86.1058 107.939 86.309C107.915 86.3769 107.882 86.4417 107.855 86.5089C107.841 86.5457 107.832 86.5844 107.818 86.6211C107.818 86.6231 107.785 86.7048 107.776 86.687C107.792 86.7173 107.819 86.7537 107.85 86.7672C107.856 86.7591 107.862 86.7504 107.867 86.7413Z"
        fill="url(#paint12_linear_1293_2539)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M103.15 77.6773C103.15 77.6773 103.389 77.0096 102.781 76.8906C102.174 76.7717 102.753 78.5445 102.753 78.5445L103.15 77.6773Z"
        fill="url(#paint13_linear_1293_2539)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M108.008 79.4889L108.248 82.1053C108.248 82.1053 106.857 82.9122 105.66 82.2068L105.873 79.9215L108.008 79.4889Z"
        fill="url(#paint14_linear_1293_2539)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M102.87 77.6286C102.87 77.6286 102.26 76.5922 103.036 76.0473C103.036 76.0473 102.62 75.1353 103.408 74.4757C103.408 74.4757 104.662 71.5604 107.296 73.6053C107.296 73.6053 109.563 72.9358 110.292 75.7355C110.292 75.7355 111.046 76.1557 110.701 77.2016C110.701 77.2016 110.786 81.0818 107.363 79.7738L102.87 77.6286Z"
        fill="url(#paint15_linear_1293_2539)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M103.996 75.4613C103.996 75.4613 101.095 79.802 104.093 81.1316C106.922 82.3865 108.114 79.5041 108.114 79.5041C108.114 79.5041 109.358 78.2244 108.94 77.239C108.522 76.2537 104.703 74.922 103.996 75.4613Z"
        fill="url(#paint16_linear_1293_2539)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M108.397 78.8204C108.397 78.8204 105.557 77.9279 105.8 76.2628C105.8 76.2628 105.308 76.3116 105.157 75.7363C105.157 75.7363 103.764 76.981 103.396 76.1106C103.396 76.1106 103.64 73.9555 105.343 74.6539C107.045 75.3523 108.6 76.0626 109.056 76.5598C109.512 77.057 109.89 78.2602 108.397 78.8204Z"
        fill="url(#paint17_linear_1293_2539)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M107.742 79.8915L108.246 78.5147C108.246 78.5147 109.221 78.07 109.092 78.819C108.964 79.5681 108.088 79.9818 107.742 79.8915Z"
        fill="url(#paint18_linear_1293_2539)"
      />
      <path
        d="M98.4542 101.064L92.8325 111.098C92.7893 111.175 92.6924 111.204 92.6138 111.163L87.3826 108.452C87.1148 108.313 87.0557 107.956 87.2644 107.738C87.4452 107.549 87.7307 107.507 87.9587 107.634L92.3151 110.073C92.3967 110.119 92.4998 110.087 92.5419 110.004L96.6696 101.799C96.6974 101.743 96.7539 101.709 96.8158 101.709L98.4542 101.064Z"
        fill="url(#paint19_linear_1293_2539)"
      />
      <path
        d="M101.16 95.4267L91.9343 98.7126C91.7375 98.7827 91.5923 98.9505 91.5521 99.1543L89.6523 107.438C89.8039 107.994 90.1358 107.96 90.8706 107.474C91.9678 105.042 93.5108 102.556 93.463 101.201C93.5547 100.934 93.7904 100.74 94.0723 100.701L99.4992 99.9453L101.16 95.4267Z"
        fill="url(#paint20_linear_1293_2539)"
      />
      <path
        d="M90.9171 107.206C90.3677 107.621 90.0197 107.694 89.6865 107.287C88.5563 107.451 88.0679 107.849 88.0596 108.424C89.1748 108.644 90.2882 108.693 91.3974 108.38C91.3652 107.867 91.2358 107.192 90.9171 107.206Z"
        fill="url(#paint21_linear_1293_2539)"
      />
      <path
        d="M104.987 96.1108C103.755 98.0467 98.6086 100.478 95.6983 101.104C94.639 100.386 93.6681 99.3996 93.2944 98.2014C94.7982 97.0569 100.84 95.3187 103.75 94.3958L104.987 96.1108Z"
        fill="url(#paint22_linear_1293_2539)"
      />
      <path
        d="M112.812 98.254L115.039 99.1388L114.957 85.9993C114.125 84.6772 113.422 84.8209 112.812 85.9993V98.254Z"
        fill="url(#paint23_linear_1293_2539)"
      />
      <path
        d="M102.63 96.2015L93.404 99.4874C93.2071 99.5575 93.0619 99.7253 93.0217 99.9291L91.3833 108.239C91.5349 108.795 91.8184 108.82 92.5532 108.335C93.6504 105.902 94.9804 103.331 94.9326 101.976C95.0244 101.709 95.26 101.515 95.542 101.476L100.969 100.72L102.63 96.2015Z"
        fill="url(#paint24_linear_1293_2539)"
      />
      <path
        d="M92.6221 108.177C92.0627 108.586 91.7115 108.653 91.3829 108.239C90.2435 108.385 89.7458 108.778 89.728 109.356C90.8462 109.596 91.9653 109.663 93.0862 109.365C93.0621 108.848 92.9428 108.168 92.6221 108.177Z"
        fill="url(#paint25_linear_1293_2539)"
      />
      <path
        d="M111.537 96.8514C110.304 98.7873 98.8323 101.581 95.9219 102.208C95.0805 101.637 94.2947 100.898 93.8198 100.017C93.6057 99.6196 93.7577 99.1235 94.1561 98.908C96.3097 97.743 102.265 95.6122 104.862 94.7886L111.537 96.8514Z"
        fill="url(#paint26_linear_1293_2539)"
      />
      <path
        d="M112.838 95.5582L95.0263 99.1462C93.8111 99.4108 92.9382 100.47 92.9172 101.705L92.7422 111.982H93.9593L94.7695 102.047L112.172 100.271L112.838 95.5582Z"
        fill="url(#paint27_linear_1293_2539)"
      />
      <path
        d="M98.4815 113.15H93.0094C92.9371 113.15 92.8779 113.091 92.8779 113.018V112.298C92.8779 112.226 92.9371 112.167 93.0094 112.167H98.4815C98.5538 112.167 98.613 112.226 98.613 112.298V113.018C98.613 113.091 98.5538 113.15 98.4815 113.15Z"
        fill="url(#paint28_linear_1293_2539)"
      />
      <path
        d="M93.2944 117.301C94.8412 117.301 96.0952 116.056 96.0952 114.52C96.0952 112.984 94.8412 111.739 93.2944 111.739C91.7476 111.739 90.4937 112.984 90.4937 114.52C90.4937 116.056 91.7476 117.301 93.2944 117.301Z"
        fill="url(#paint29_linear_1293_2539)"
      />
      <path
        d="M93.2942 116.653C94.4808 116.653 95.4428 115.698 95.4428 114.52C95.4428 113.342 94.4808 112.387 93.2942 112.387C92.1075 112.387 91.1455 113.342 91.1455 114.52C91.1455 115.698 92.1075 116.653 93.2942 116.653Z"
        fill="url(#paint30_linear_1293_2539)"
      />
      <path
        d="M117.684 81.6134C112.87 80.2324 111.432 82.1164 111.85 87.6307V98.1606H113.052V85.7027C113.157 82.9889 114.058 82.1945 117.238 83.1917C118.262 83.3185 118.793 81.9516 117.684 81.6134Z"
        fill="url(#paint31_linear_1293_2539)"
      />
      <path
        d="M112.255 95.7117L98.5713 95.7941V95.7539C98.5713 95.0905 99.1013 94.5467 99.7691 94.525L111.674 94.1384C112.153 94.1229 112.518 94.5618 112.412 95.0266L112.255 95.7117Z"
        fill="url(#paint32_linear_1293_2539)"
      />
      <path
        d="M108.406 119.005C114.687 119.005 119.78 113.948 119.78 107.711C119.78 101.474 114.687 96.418 108.406 96.418C102.124 96.418 97.0317 101.474 97.0317 107.711C97.0317 113.948 102.124 119.005 108.406 119.005Z"
        fill="url(#paint33_linear_1293_2539)"
      />
      <path
        opacity={0.51}
        d="M108.6 117.578C113.981 117.578 118.344 113.247 118.344 107.904C118.344 102.561 113.981 98.2296 108.6 98.2296C103.219 98.2296 98.8564 102.561 98.8564 107.904C98.8564 113.247 103.219 117.578 108.6 117.578Z"
        fill="url(#paint34_linear_1293_2539)"
      />
      <path
        d="M93.5342 86.227L99.3337 85.7813C99.5711 85.7631 99.7958 85.8986 99.9053 86.1259L104.245 95.1413C104.454 95.5758 104.152 96.0921 103.697 96.077L98.6635 95.9088C98.469 95.9023 98.2898 95.794 98.1833 95.6188L93.0779 87.2174C92.8292 86.808 93.0808 86.2619 93.5342 86.227Z"
        fill="url(#paint35_linear_1293_2539)"
      />
      <path
        d="M110.008 88.0943C109.325 87.7684 108.606 87.4447 108.119 86.9615L105.876 89.5795C105.876 89.5795 101.261 87.9481 100.244 88.6806C99.2283 89.4131 99.6272 89.4747 99.7329 89.4947C99.8386 89.5146 100.428 89.0821 100.428 89.0821C100.428 89.0821 99.8768 89.6415 100.102 89.7137C100.326 89.7859 101.005 89.286 101.005 89.286C101.005 89.286 100.389 89.999 100.684 89.9595C100.979 89.92 101.287 89.5294 101.287 89.5294C101.287 89.5294 100.819 89.9728 101.066 90.039C101.313 90.1053 101.781 89.736 101.781 89.736C101.781 89.736 102.318 90.1113 102.655 90.1748C102.992 90.2383 106.226 91.7204 106.908 91.4864C107.589 91.2524 110.008 88.0943 110.008 88.0943Z"
        fill="url(#paint36_linear_1293_2539)"
      />
      <path
        d="M90.5362 59.0114C86.5182 60.2534 82.6204 63.3626 83.1631 67.332C83.6246 70.7074 88.1121 71.7038 90.8344 72.0595C91.5937 72.1587 92.2836 72.4947 92.7763 73.003C93.9554 74.2197 96.4812 76.2474 99.253 74.8977C99.4549 74.7994 99.3646 74.5317 99.133 74.5396C98.3961 74.5649 97.3504 74.4733 96.6386 73.8757C95.6692 73.0617 96.0202 71.6494 97.273 71.2095C99.6438 70.377 104.118 68.1104 103.538 62.9738C102.755 56.027 90.5362 59.0114 90.5362 59.0114Z"
        fill="url(#paint37_linear_1293_2539)"
      />
      <path
        d="M92.9827 64.5517C92.9827 64.5517 93.1805 62.2292 95.8628 62.613C98.4039 62.9767 97.5903 65.9773 94.0102 67.8869C93.6221 68.0939 93.1414 68.1243 92.7215 67.9702C91.1496 67.3934 87.4884 65.7412 89.5077 63.4468C90.8119 61.9652 92.9827 64.5517 92.9827 64.5517Z"
        fill="white"
      />
      <path
        opacity={0.7}
        d="M84.702 64.4595C84.6684 64.4595 84.6342 64.4538 84.6013 64.4418C84.4703 64.3937 84.4093 64.2631 84.4649 64.15C85.9576 61.118 89.5264 59.7687 92.2574 59.1706C92.3955 59.1401 92.5356 59.2124 92.5706 59.3315C92.6057 59.4506 92.5222 59.5716 92.3842 59.6018C89.7662 60.1751 86.3494 61.4597 84.9394 64.324C84.8976 64.4087 84.8023 64.4595 84.702 64.4595Z"
        fill="white"
      />
      <path
        opacity={0.7}
        d="M84.1121 67.5545C83.9862 67.5545 83.876 67.4748 83.8574 67.364C83.8543 67.3459 83.7833 66.9121 83.854 66.2415C83.867 66.1192 83.992 66.0286 84.1341 66.0403C84.2759 66.0514 84.3803 66.1596 84.3674 66.282C84.3021 66.9006 84.3668 67.296 84.3674 67.3C84.3879 67.4216 84.2904 67.5344 84.1495 67.5521C84.1369 67.5537 84.1244 67.5545 84.1121 67.5545Z"
        fill="white"
      />
      <path
        d="M37.1325 71.7264C37.1325 71.7264 34.1221 78.6738 32.2694 77.7475C30.4168 76.8211 29.0273 69.1791 29.0273 69.1791C29.0273 69.1791 35.8629 67.1228 37.1325 71.7264Z"
        fill="url(#paint38_linear_1293_2539)"
      />
      <path
        d="M26.6507 114.838C26.6507 114.838 26.3991 116.263 26.2757 117.673C26.2275 118.225 26.6524 118.703 27.2052 118.726C29.0834 118.805 33.101 118.957 34.5426 118.892C34.7593 118.883 34.901 118.661 34.8208 118.459C34.7536 118.29 34.6239 118.154 34.4588 118.078L27.8225 115.028L26.6507 114.838Z"
        fill="url(#paint39_linear_1293_2539)"
      />
      <path
        d="M26.4448 114.001L26.647 115.705C26.647 115.705 27.8095 116.247 28.6034 115.637L28.122 113.738L26.4448 114.001Z"
        fill="url(#paint40_linear_1293_2539)"
      />
      <path
        d="M26.5962 81.9615C26.5088 82.4065 26.1274 104.17 28.4537 113.923C28.4916 114.082 28.411 114.247 28.2595 114.308C27.9028 114.454 27.2033 114.665 26.3649 114.693C26.1053 114.702 25.8726 114.533 25.7993 114.284C25.1343 112.021 21.9478 100.684 21.5321 89.8534C21.0676 77.7514 21.5321 89.4413 21.5321 89.4413L21.8045 81.9606L26.5962 81.9615Z"
        fill="url(#paint41_linear_1293_2539)"
      />
      <path
        d="M19.0164 115.582C19.0164 115.582 18.6158 116.301 18.2279 118.212C18.1579 118.557 18.3991 118.888 18.7496 118.922C19.3698 118.983 20.3245 119.062 21.0893 119.056C21.4418 119.054 21.717 118.747 21.6745 118.397C21.5898 117.699 21.3259 116.555 20.5107 115.663L19.0164 115.582Z"
        fill="url(#paint42_linear_1293_2539)"
      />
      <path
        d="M18.665 113.39L19.1375 115.967C19.1375 115.967 19.6047 116.314 20.5288 116.062L20.3033 113.29L18.665 113.39Z"
        fill="url(#paint43_linear_1293_2539)"
      />
      <path
        d="M17.3887 82.6294C15.486 94.1121 17.8014 111.01 18.5823 114.317C18.6301 114.52 18.7935 114.675 18.9988 114.709C19.3473 114.767 19.9212 114.814 20.4869 114.649C20.6819 114.593 20.8188 114.417 20.8268 114.214C20.9316 111.54 20.743 95.1254 22.5158 88.6381C22.6057 88.3094 22.8065 88.0226 23.0842 87.8252L26.5253 85.3789L26.789 81.4248L17.3887 82.6294Z"
        fill="url(#paint44_linear_1293_2539)"
      />
      <path
        d="M29.7217 61.3055C22.7744 60.6107 17.5187 62.369 17.5187 62.369C15.8191 72.2862 17.2215 83.7251 17.2215 83.7251C21.6358 84.8827 26.6154 83.0173 26.6154 83.0173C27.349 78.8721 30.7722 67.2062 30.7722 67.2062C33.5581 66.8605 31.4718 61.4805 29.7217 61.3055Z"
        fill="url(#paint45_linear_1293_2539)"
      />
      <path
        d="M24.789 72.4274C24.789 72.4274 17.8626 75.6399 16.2471 73.6159C15.7911 73.0445 15.8097 72.3452 15.9129 71.7775C14.1204 70.8724 12.4069 70.6261 11.4005 70.5519C11.1364 71.9351 11.4564 73.6657 12.3661 75.0952C15.6591 80.2699 25.6432 74.0801 25.6432 74.0801L24.789 72.4274Z"
        fill="url(#paint46_linear_1293_2539)"
      />
      <path
        d="M27.0728 74.1157L29.5308 65.532C29.5587 65.4346 29.6418 65.3635 29.7425 65.3518C30.1879 65.2998 31.4782 65.1539 32.9681 65.0279C34.7628 64.8761 36.8469 64.7531 38.0924 64.8577C38.2694 64.8726 38.3764 65.0599 38.2976 65.2192C37.5894 66.652 34.6763 72.4803 33.2174 74.3896C33.1691 74.4529 33.0944 74.4898 33.0148 74.4891L27.312 74.436C27.146 74.4345 27.0272 74.2753 27.0728 74.1157Z"
        fill="url(#paint47_linear_1293_2539)"
      />
      <path
        d="M24.8939 74.6071C24.8939 74.6071 24.4393 72.7378 24.6227 72.0747C24.806 71.4115 25.1613 70.5588 26.3457 70.7483C27.5299 70.9378 28.9269 71.4366 28.9269 71.4366C28.9269 71.4366 28.8564 72.3005 27.9563 72.0218L28.5145 72.4537C28.5145 72.4537 28.4347 73.1453 27.6744 72.7758L28.1935 73.3485C28.1935 73.3485 27.867 73.9166 27.3077 73.5523C26.7483 73.1879 26.4802 74.8323 24.8939 74.6071Z"
        fill="url(#paint48_linear_1293_2539)"
      />
      <path
        d="M37.0274 71.8259C37.0274 71.8259 38.4055 70.4836 38.6025 69.8244C38.7994 69.1651 38.9514 68.2539 37.8474 67.7853C36.7434 67.3167 35.2947 66.9973 35.2947 66.9973C35.2947 66.9973 34.8956 67.7667 35.8063 68.0087L35.1039 68.0781C35.1039 68.0781 34.8041 68.7065 35.6446 68.7973L34.9005 69.0067C34.9005 69.0067 34.8753 69.6615 35.5428 69.65C36.2102 69.6383 35.5639 71.174 37.0274 71.8259Z"
        fill="url(#paint49_linear_1293_2539)"
      />
      <path
        d="M24.4313 56.6739L22.617 61.9206C22.587 62.0075 22.6227 62.1038 22.7031 62.1483C23.1977 62.4217 24.9795 63.2121 27.1267 61.8507C27.3504 61.7089 27.5026 61.4776 27.5366 61.2149L28.1241 56.6739H24.4313Z"
        fill="url(#paint50_linear_1293_2539)"
      />
      <path
        d="M29.5024 53.3037C29.5024 53.3037 30.0824 57.5104 29.3213 58.8449C28.5603 60.1794 26.2794 59.2277 24.6784 57.3305L24.6572 53.01L29.5024 53.3037Z"
        fill="url(#paint51_linear_1293_2539)"
      />
      <path
        d="M25.4524 55.4961C25.5481 55.4898 25.6153 55.4002 25.5936 55.3069C25.5276 55.023 25.4179 54.453 25.4782 54.0112C25.4782 54.0112 25.2208 53.6726 26.5176 53.8242C27.8143 53.9758 29.7544 54.1844 30.5 53.3067C31.227 52.4508 31.1816 49.6119 28.9278 51.0346C28.842 51.0888 28.7276 51.0487 28.6973 50.952C28.5663 50.5343 28.156 49.6168 27.0919 49.6919C26.0961 49.7621 25.7701 50.3535 25.6661 50.6737C25.6355 50.7679 25.526 50.8096 25.441 50.7588C25.0388 50.5179 24.0272 50.0667 23.1529 50.9536C22.4326 51.6841 22.51 52.2755 22.6572 52.6047C22.7049 52.7113 22.6239 52.8286 22.5072 52.8222C22.1912 52.8051 21.7359 52.9115 21.5287 53.5907C21.2421 54.5297 22.3009 54.8258 22.6092 54.8912C22.6598 54.9019 22.7021 54.9361 22.7214 54.984C22.8707 55.354 23.57 56.9492 24.7428 57.5405C24.8444 57.5917 24.9649 57.517 24.9672 57.4034L25.0018 55.6681C25.0035 55.5875 25.0665 55.5215 25.1469 55.5162L25.4524 55.4961Z"
        fill="url(#paint52_linear_1293_2539)"
      />
      <path
        d="M25.5858 55.7929C25.5858 55.7929 24.5888 54.391 24.2095 55.1249C23.8302 55.8587 25.0003 56.679 25.7477 56.6275L25.5858 55.7929Z"
        fill="url(#paint53_linear_1293_2539)"
      />
      <path
        d="M19.7063 67.89L17.5193 62.3689C17.5193 62.3689 12.3088 65.9092 11.3477 70.4261C11.3309 70.5049 11.3876 70.5809 11.4679 70.5878C12.4994 70.6765 14.2409 70.955 15.9474 71.8166C16.3413 69.6502 19.7063 67.89 19.7063 67.89Z"
        fill="url(#paint54_linear_1293_2539)"
      />
      <path
        d="M28.3513 55.3342L28.2275 55.1698C28.244 55.1573 28.6341 54.8636 29.027 54.9216C29.2017 54.9474 29.3468 55.0383 29.4585 55.1912L29.2922 55.3128C29.2131 55.2044 29.1164 55.1432 28.9966 55.1254C28.6941 55.0807 28.355 55.3314 28.3513 55.3342Z"
        fill="url(#paint55_linear_1293_2539)"
      />
      <path
        d="M28.4032 55.1805C28.4032 55.7407 28.0451 56.1948 27.6032 56.1948C27.1614 56.1948 26.8032 55.7407 26.8032 55.1805C26.8032 54.6204 27.1614 54.1663 27.6032 54.1663C28.045 54.1663 28.4032 54.6204 28.4032 55.1805Z"
        fill="url(#paint56_linear_1293_2539)"
      />
      <path
        d="M30.461 55.1805C30.461 55.7407 30.1987 56.1948 29.8753 56.1948C29.5518 56.1948 29.2896 55.7407 29.2896 55.1805C29.2896 54.6204 29.5518 54.1663 29.8753 54.1663C30.1987 54.1663 30.461 54.6204 30.461 55.1805Z"
        fill="url(#paint57_linear_1293_2539)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1293_2539"
        x1={124.825}
        y1={132.775}
        x2={45.7179}
        y2={47.3903}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DAE3FE" />
        <stop offset={1} stopColor="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1293_2539"
        x1={52.9537}
        y1={22.4037}
        x2={52.1952}
        y2={123.077}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DAE3FE" />
        <stop offset={1} stopColor="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1293_2539"
        x1={42.8894}
        y1={86.2106}
        x2={135.797}
        y2={24.7129}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#09005D" />
        <stop offset={1} stopColor="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1293_2539"
        x1={111.012}
        y1={66.1896}
        x2={111.555}
        y2={66.1896}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DAE3FE" />
        <stop offset={1} stopColor="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_1293_2539"
        x1={79.3818}
        y1={52.7041}
        x2={111.865}
        y2={52.7041}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DAE3FE" />
        <stop offset={1} stopColor="#E9EFFD" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_1293_2539"
        x1={64.2726}
        y1={99.3424}
        x2={47.3724}
        y2={27.9857}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#09005D" />
        <stop offset={1} stopColor="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_1293_2539"
        x1={51.0258}
        y1={65.472}
        x2={23.616}
        y2={109.328}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#09005D" />
        <stop offset={1} stopColor="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_1293_2539"
        x1={45.452}
        y1={92.492}
        x2={70.3166}
        y2={138.11}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#09005D" />
        <stop offset={1} stopColor="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_1293_2539"
        x1={95.2918}
        y1={81.2853}
        x2={101.697}
        y2={89.0201}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEBBBA" />
        <stop offset={1} stopColor="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_1293_2539"
        x1={94.9025}
        y1={81.6069}
        x2={101.307}
        y2={89.341}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEBBBA" />
        <stop offset={1} stopColor="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_1293_2539"
        x1={95.7822}
        y1={83.279}
        x2={96.7148}
        y2={83.279}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF928E" />
        <stop offset={1} stopColor="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_1293_2539"
        x1={-59.9017}
        y1={-246.124}
        x2={-53.1142}
        y2={-232.549}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF928E" />
        <stop offset={1} stopColor="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_1293_2539"
        x1={-154.024}
        y1={-439.73}
        x2={-147.236}
        y2={-426.155}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E1473D" />
        <stop offset={1} stopColor="#E9605A" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_1293_2539"
        x1={101.276}
        y1={80.4713}
        x2={105.661}
        y2={71.8781}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEBBBA" />
        <stop offset={1} stopColor="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_1293_2539"
        x1={108.23}
        y1={86.0818}
        x2={105.891}
        y2={77.3134}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEBBBA" />
        <stop offset={1} stopColor="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_1293_2539"
        x1={87.3433}
        y1={14.3682}
        x2={97.6982}
        y2={47.7165}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#09005D" />
        <stop offset={1} stopColor="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_1293_2539"
        x1={104.294}
        y1={81.0669}
        x2={107.78}
        y2={74.2359}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEBBBA" />
        <stop offset={1} stopColor="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_1293_2539"
        x1={81.652}
        y1={18.4387}
        x2={95.3306}
        y2={50.6037}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#09005D" />
        <stop offset={1} stopColor="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_1293_2539"
        x1={106.861}
        y1={82.266}
        x2={110.292}
        y2={75.5421}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEBBBA" />
        <stop offset={1} stopColor="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint19_linear_1293_2539"
        x1={87.602}
        y1={113.728}
        x2={105.567}
        y2={81.9736}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4F52FF" />
        <stop offset={1} stopColor="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint20_linear_1293_2539"
        x1={91.4972}
        y1={97.0767}
        x2={94.3114}
        y2={100.262}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEBBBA" />
        <stop offset={1} stopColor="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint21_linear_1293_2539"
        x1={88.0452}
        y1={101.368}
        x2={89.2752}
        y2={106.411}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#09005D" />
        <stop offset={1} stopColor="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint22_linear_1293_2539"
        x1={96.0831}
        y1={66.0212}
        x2={98.0048}
        y2={85.5878}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4F52FF" />
        <stop offset={1} stopColor="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint23_linear_1293_2539"
        x1={106.274}
        y1={110.058}
        x2={114.022}
        y2={92.3469}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#09005D" />
        <stop offset={1} stopColor="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint24_linear_1293_2539"
        x1={95.9315}
        y1={98.8186}
        x2={98.3245}
        y2={106.396}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEBBBA" />
        <stop offset={1} stopColor="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint25_linear_1293_2539"
        x1={93.2806}
        y1={106.542}
        x2={98.6309}
        y2={98.8552}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#09005D" />
        <stop offset={1} stopColor="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint26_linear_1293_2539"
        x1={102.269}
        y1={98.1914}
        x2={119.914}
        y2={115.487}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4F52FF" />
        <stop offset={1} stopColor="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint27_linear_1293_2539"
        x1={119.849}
        y1={78.8152}
        x2={114.56}
        y2={85.457}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#09005D" />
        <stop offset={1} stopColor="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint28_linear_1293_2539"
        x1={94.0005}
        y1={108.51}
        x2={97.0799}
        y2={115.83}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#09005D" />
        <stop offset={1} stopColor="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint29_linear_1293_2539"
        x1={92.6787}
        y1={124.372}
        x2={93.4166}
        y2={112.565}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#09005D" />
        <stop offset={1} stopColor="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint30_linear_1293_2539"
        x1={95.5053}
        y1={110.474}
        x2={91.3868}
        y2={118.01}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4F52FF" />
        <stop offset={1} stopColor="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint31_linear_1293_2539"
        x1={118.631}
        y1={72.9565}
        x2={105.778}
        y2={110.716}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4F52FF" />
        <stop offset={1} stopColor="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint32_linear_1293_2539"
        x1={159.271}
        y1={53.9166}
        x2={134.209}
        y2={73.2349}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#09005D" />
        <stop offset={1} stopColor="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint33_linear_1293_2539"
        x1={117.121}
        y1={115.212}
        x2={96.8269}
        y2={97.7465}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#09005D" />
        <stop offset={1} stopColor="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint34_linear_1293_2539"
        x1={113.364}
        y1={90.4379}
        x2={105.615}
        y2={118.85}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4F52FF" />
        <stop offset={1} stopColor="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint35_linear_1293_2539"
        x1={94.1902}
        y1={99.9411}
        x2={105.252}
        y2={78.121}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#09005D" />
        <stop offset={1} stopColor="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint36_linear_1293_2539"
        x1={115.375}
        y1={90.9029}
        x2={70.6282}
        y2={81.6284}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEBBBA" />
        <stop offset={1} stopColor="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint37_linear_1293_2539"
        x1={64.3047}
        y1={98.8585}
        x2={99.1106}
        y2={61.0128}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E1473D" />
        <stop offset={1} stopColor="#E9605A" />
      </linearGradient>
      <linearGradient
        id="paint38_linear_1293_2539"
        x1={29.0273}
        y1={73.2769}
        x2={37.1325}
        y2={73.2769}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEBBBA" />
        <stop offset={1} stopColor="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint39_linear_1293_2539"
        x1={30.4148}
        y1={102.447}
        x2={30.5881}
        y2={121.509}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4F52FF" />
        <stop offset={1} stopColor="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint40_linear_1293_2539"
        x1={26.4448}
        y1={114.832}
        x2={28.6034}
        y2={114.832}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEBBBA" />
        <stop offset={1} stopColor="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint41_linear_1293_2539"
        x1={24.0052}
        y1={123.046}
        x2={25.4785}
        y2={83.5141}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4F52FF" />
        <stop offset={1} stopColor="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint42_linear_1293_2539"
        x1={19.8032}
        y1={102.543}
        x2={19.9765}
        y2={121.605}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4F52FF" />
        <stop offset={1} stopColor="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint43_linear_1293_2539"
        x1={18.665}
        y1={114.722}
        x2={20.5288}
        y2={114.722}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEBBBA" />
        <stop offset={1} stopColor="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint44_linear_1293_2539"
        x1={20.362}
        y1={122.91}
        x2={21.8353}
        y2={83.3784}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4F52FF" />
        <stop offset={1} stopColor="#4042E2" />
      </linearGradient>
      <linearGradient
        id="paint45_linear_1293_2539"
        x1={-219.536}
        y1={-414.409}
        x2={-212.748}
        y2={-400.834}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF928E" />
        <stop offset={1} stopColor="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint46_linear_1293_2539"
        x1={11.311}
        y1={73.8552}
        x2={25.6432}
        y2={73.8552}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEBBBA" />
        <stop offset={1} stopColor="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint47_linear_1293_2539"
        x1={29.138}
        y1={61.3049}
        x2={33.7397}
        y2={72.1013}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#09005D" />
        <stop offset={1} stopColor="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint48_linear_1293_2539"
        x1={24.5791}
        y1={72.6749}
        x2={28.9269}
        y2={72.6749}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEBBBA" />
        <stop offset={1} stopColor="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint49_linear_1293_2539"
        x1={38.3206}
        y1={70.3561}
        x2={34.6369}
        y2={68.0464}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEBBBA" />
        <stop offset={1} stopColor="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint50_linear_1293_2539"
        x1={22.6064}
        y1={59.6497}
        x2={28.1241}
        y2={59.6497}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEBBBA" />
        <stop offset={1} stopColor="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint51_linear_1293_2539"
        x1={29.0073}
        y1={57.7278}
        x2={24.5845}
        y2={52.1658}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEBBBA" />
        <stop offset={1} stopColor="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint52_linear_1293_2539"
        x1={22.9118}
        y1={47.3984}
        x2={28.1403}
        y2={55.9079}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#09005D" />
        <stop offset={1} stopColor="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint53_linear_1293_2539"
        x1={27.0369}
        y1={58.475}
        x2={23.0577}
        y2={53.4709}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEBBBA" />
        <stop offset={1} stopColor="#FF928E" />
      </linearGradient>
      <linearGradient
        id="paint54_linear_1293_2539"
        x1={-224.696}
        y1={-411.828}
        x2={-217.909}
        y2={-398.253}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF928E" />
        <stop offset={1} stopColor="#FE7062" />
      </linearGradient>
      <linearGradient
        id="paint55_linear_1293_2539"
        x1={29.2262}
        y1={54.8873}
        x2={28.4587}
        y2={55.4745}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#09005D" />
        <stop offset={1} stopColor="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint56_linear_1293_2539"
        x1={32.4013}
        y1={51.5093}
        x2={22.3911}
        y2={59.1686}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#09005D" />
        <stop offset={1} stopColor="#1A0F91" />
      </linearGradient>
      <linearGradient
        id="paint57_linear_1293_2539"
        x1={34.061}
        y1={51.9778}
        x2={25.3282}
        y2={58.6597}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#09005D" />
        <stop offset={1} stopColor="#1A0F91" />
      </linearGradient>
      <clipPath id="clip0_1293_2539">
        <rect width={130} height={130} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default WalkthroughIcon;

